interface MediaDisplayProps {
  imageUrl?: string | null;
  videoUrl?: string | null;
  hasImage?: boolean;
  hasVideo?: boolean;
  alt?: string;
}

export default function MediaDisplay({
  imageUrl,
  videoUrl,
  hasImage,
  hasVideo,
  alt = "Question media",
}: MediaDisplayProps) {
  if (hasImage && imageUrl) {
    return (
      <div className="mt-4 mb-4 rounded-lg overflow-hidden border border-gray-200 bg-gray-50">
        <img
          src={imageUrl}
          alt={alt}
          className="w-full max-h-80 object-contain"
          loading="lazy"
        />
      </div>
    );
  }

  if (hasVideo && videoUrl) {
    return (
      <div className="mt-4 mb-4 rounded-lg overflow-hidden border border-gray-200 bg-gray-900">
        <video
          src={videoUrl}
          controls
          className="w-full max-h-80"
          preload="metadata"
        >
          <track kind="captions" />
          Your browser does not support the video element.
        </video>
      </div>
    );
  }

  return null;
}
